<rt-dialog-body variant="default no-padding white" overflow-hidden>
  <div layout-vertical layout-full-width>
    <div class="header" layout-centered padding-small-x>
      <rt-badge
        *ngIf="hasBadge"
        [color]="badgeColor"
        text="{{
          (availableFromPlan === BillingPlanTier.Scale
            ? 'app.pricing.scale'
            : availableFromPlan === BillingPlanTier.Lead
            ? 'app.pricing.lead'
            : availableFromPlan === BillingPlanTier.Grow
            ? 'app.pricing.grow'
            : availableFromPlan === BillingPlanTier.Optimize
            ? 'app.pricing.optimize'
            : ''
          ) | translate
        }}"
      >
      </rt-badge>
      <rt-heading variant="heading large" margin-left-small-x>
        <ng-container *ngIf="availableFromPlan === BillingPlanTier.Launch">
          {{ 'app.pricing.feature_guard.available_in_launch' | translate }}
        </ng-container>
        <ng-container *ngIf="availableFromPlan === BillingPlanTier.Scale">
          {{ 'app.pricing.feature_guard.available_in_scale' | translate }}
        </ng-container>
        <ng-container *ngIf="availableFromPlan === BillingPlanTier.Lead">
          {{ 'app.pricing.feature_guard.available_in_lead' | translate }}
        </ng-container>
        <ng-container *ngIf="availableFromPlan === BillingPlanTier.Start">
          {{ 'app.pricing.feature_guard.available_in_start' | translate }}
        </ng-container>
        <ng-container *ngIf="availableFromPlan === BillingPlanTier.Grow">
          {{ 'app.pricing.feature_guard.available_in_grow' | translate }}
        </ng-container>
        <ng-container *ngIf="availableFromPlan === BillingPlanTier.Optimize">
          {{ 'app.pricing.feature_guard.available_in_optimize' | translate }}
        </ng-container>
      </rt-heading>
    </div>
    <rt-feature-guard-content
      [featureData]="featureData"
      [canUpgrade]="canUpgrade"
      [availableFromPlan]="availableFromPlan"
      (openPlanPicker)="openPlanPicker()"
    >
    </rt-feature-guard-content>
  </div>
</rt-dialog-body>
